import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { Box, Typography } from '@material-ui/core';

import useStyles from './useStyles';

const MobileCalculationsResult = props => {
  const { homePrice, downPayment, mortgagePayment } = props;
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Box className={classes.container}>
      <Box display="flex" width="100%" justifyContent="center">
        <Typography variant="h2" color="inherit" className={classes.text}>
          {`${t('components.AffordabilityCalculator.MobileCalculationsResult.homeValue')}:`}
        </Typography>
        <Typography variant="h2" className={classes.homePrice}>
          {homePrice}
        </Typography>
      </Box>
      <Box className={classes.divider} />
      <Box display="flex" width="100%" justifyContent="space-between">
        <Box
          width="47%"
          height={40}
          display="flex"
          flexDirection="column"
          justifyContent="space-between"
          alignItems="end"
        >
          <Typography variant="subtitle1" color="secondary">
            {t('components.AffordabilityCalculator.MobileCalculationsResult.downPayment')}
          </Typography>
          <Typography variant="h2">{downPayment}</Typography>
        </Box>
        <Box
          width="47%"
          height={40}
          display="flex"
          flexDirection="column"
          justifyContent="space-between"
          alignItems="start"
        >
          <Typography variant="subtitle1" color="secondary">
            {t('components.AffordabilityCalculator.MobileCalculationsResult.mortgagePayment')}
          </Typography>
          <Typography variant="h2">{mortgagePayment}</Typography>
        </Box>
      </Box>
    </Box>
  );
};

MobileCalculationsResult.propTypes = {
  homePrice: PropTypes.string.isRequired,
  downPayment: PropTypes.string.isRequired,
  mortgagePayment: PropTypes.string.isRequired,
};

export default MobileCalculationsResult;



// WEBPACK FOOTER //
// ./src/sharedComponents/AffordabilityCalculator/components/MobileCalculationsResult/MobileCalculationsResult.js